import { useIntl } from 'react-intl';

export const TrlFormattedMessagePlain = (props) => {
  const { id, values } = props;
  const intl = useIntl();
  return intl.formatMessage({ id }, { ...values });
};

export const TrlFormattedNumberPlain = (value, decimalDigits) => {
  const intl = useIntl();
  return intl.formatNumber(value, {
    minimumFractionDigits: decimalDigits,
    maximumFractionDigits: decimalDigits,
  });
};
